import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/evangadi-logo-home.png";

const Nav = ({ logout }) => {
  const isLoggedIn = Boolean(localStorage.getItem("auth-token"));

  return (
    <nav className=" flex items-center justify-between p-8 bg-gray-200">
      <div>
        <Link to="/">
          <img className="h-4 md:h-6 md:ms-20" src={logo} alt="logo" />
        </Link>
      </div>
      <div className="header__navRight space-x-4 hover:to-orange-400 ">
        <Link to="/" className="hidden md:inline-flex">
          Home
        </Link>
        <span className=" hidden md:inline-flex">How it Works</span>
        <span className=" md-pe-16">
          {isLoggedIn ? (
            <button
              onClick={logout}
              className=" bg-blue-700 text-white  py-1 px-10 rounded text-xs me-8"
            >
              LogOut
            </button>
          ) : (
            <Link
              to="/login"
              className="inline-block bg-blue-700 text-white py-1 px-10 rounded text-xs me-8"
            >
              SIGN IN
            </Link>
          )}
        </span>
      </div>
    </nav>
  );
};

export default Nav;
